import React, { FC } from 'react'
import { FlexContainer, Text2XL, TextBase, elM5, elFlex1, elHFull } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { cx } from '@linaria/core'
import { PageWrapper, BrandLogo } from '@reapitform/common-ui'
import StepNavigation from '../view/step-navigation'
import { useFormDocument } from '../view/layout/tenant-app-layout'

export const SuccessInfoChangedRequest: FC = () => {
  const formDocumentData = useFormDocument()

  return (
    <ErrorBoundary>
      <StepNavigation hideTitleOnMobile>
        <PageWrapper hasFullPage>
          <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
            <BrandLogo src={formDocumentData?.agentLogoUrl || '/pwa-152x152.png'} />
            <Text2XL hasBoldText hasMargin tag="h2" hasCenteredText>
              Thanks for your request
            </Text2XL>
            <TextBase className={cx(elM5)} hasRegularText hasCenteredText>
              Your changes have been received.
            </TextBase>
          </FlexContainer>
        </PageWrapper>
      </StepNavigation>
    </ErrorBoundary>
  )
}
